import { Helmet } from "react-helmet-async";

import { SITE_NAME, SITE_URL, SITE_DESCRIPTION, IMAGES_OG } from "@/data/seo";

interface SEOProps {
  title: string;
  description?: string;
  path?: string;
}

/**
 * Per-page SEO: title, description, canonical, OpenGraph & Twitter cards.
 * NOTE (Next.js migration): replace with the App Router `metadata` export.
 */
export function SEO({ title, description = SITE_DESCRIPTION, path = "/" }: SEOProps) {
  const fullTitle = `${title} | ${SITE_NAME}`;
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* OpenGraph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={IMAGES_OG} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={IMAGES_OG} />
    </Helmet>
  );
}
